import ReactGA from 'react-ga4';
import { GA_DEBUG } from '../constants/constants';

// Guard: react-ga4 does not expose isInitialized, so we wrap calls
const safeEvent = (name, params) => {
  try {
    const payload = GA_DEBUG ? { ...params, debug_mode: true } : params;
    ReactGA.event(name, payload);
  } catch (_) {
    // noop
  }
};

export const trackAddToCart = (item) => {
  if (!item) return;

  const eventData = {
    currency: 'JPY',
    value: item.finalPrice,
    items: [
      {
        item_id: item.id,
        item_name: item.name,
        item_brand: item.shopName,
        price: item.finalPrice,
        quantity: 1,
        item_category: item.category?.name || '',
        item_category2: item.parentCategory?.name || '',
        item_variant:
          item.serviceOption === 'rent'
            ? `${item.rentalPeriod}${item.useSubscription ? ' (subscription)' : ''}`
            : 'buy',
      },
    ],
  };

  safeEvent('add_to_cart', eventData);
};

export const trackBeginCheckout = (cartItems, totalValue) => {
  if (!Array.isArray(cartItems) || cartItems.length === 0) return;

  const items = cartItems.map((item) => ({
    item_id: item.id,
    item_name: item.name,
    item_brand: item.shopName,
    price: item.finalPrice,
    quantity: 1,
    item_category: item.category?.name || '',
    item_category2: item.parentCategory?.name || '',
    item_variant:
      item.serviceOption === 'rent'
        ? `${item.rentalPeriod}${item.useSubscription ? ' (subscription)' : ''}`
        : 'buy',
  }));

  const eventData = {
    currency: 'JPY',
    value: totalValue,
    items,
  };

  safeEvent('begin_checkout', eventData);
};

export const trackPurchase = (orderId, cartLikeItems, totalValue, shippingPrice, taxPrice) => {
  if (!orderId) return;

  const items = (cartLikeItems || []).map((item) => ({
    item_id: item.productId || item.id,
    item_name: item.name,
    item_brand: item.shopName,
    price: item.finalPrice || item.price,
    quantity: 1,
    item_category: item.category?.name || '',
    item_category2: item.parentCategory?.name || '',
    item_variant:
      item.serviceOption === 'rent'
        ? `${item.rentalPeriod || item.period}${item.useSubscription ? ' (subscription)' : ''}`
        : 'buy',
  }));

  const eventData = {
    transaction_id: orderId,
    currency: 'JPY',
    value: totalValue,
    shipping: shippingPrice,
    tax: taxPrice,
    items,
  };

  safeEvent('purchase', eventData);
};

export const trackRemoveFromCart = (item) => {
  if (!item) return;

  const eventData = {
    currency: 'JPY',
    value: item.finalPrice,
    items: [
      {
        item_id: item.id,
        item_name: item.name,
        item_brand: item.shopName,
        price: item.finalPrice,
        quantity: 1,
        item_category: item.category?.name || '',
        item_category2: item.parentCategory?.name || '',
        item_variant:
          item.serviceOption === 'rent'
            ? `${item.rentalPeriod}${item.useSubscription ? ' (subscription)' : ''}`
            : 'buy',
      },
    ],
  };

  safeEvent('remove_from_cart', eventData);
};

export const trackViewCart = (cartItems, totalValue) => {
  if (!Array.isArray(cartItems) || cartItems.length === 0) return;

  const items = cartItems.map((item) => ({
    item_id: item.id,
    item_name: item.name,
    item_brand: item.shopName,
    price: item.finalPrice,
    quantity: 1,
    item_category: item.category?.name || '',
    item_category2: item.parentCategory?.name || '',
    item_variant:
      item.serviceOption === 'rent'
        ? `${item.rentalPeriod}${item.useSubscription ? ' (subscription)' : ''}`
        : 'buy',
  }));

  const eventData = {
    currency: 'JPY',
    value: totalValue,
    items,
  };

  safeEvent('view_cart', eventData);
};

export const trackAddShippingInfo = (cartItems, totalValue, shippingTier) => {
  if (!Array.isArray(cartItems) || cartItems.length === 0) return;

  const items = cartItems.map((item) => ({
    item_id: item.id,
    item_name: item.name,
    item_brand: item.shopName,
    price: item.finalPrice,
    quantity: 1,
    item_category: item.category?.name || '',
    item_category2: item.parentCategory?.name || '',
    item_variant:
      item.serviceOption === 'rent'
        ? `${item.rentalPeriod}${item.useSubscription ? ' (subscription)' : ''}`
        : 'buy',
  }));

  const eventData = {
    currency: 'JPY',
    value: totalValue,
    shipping_tier: shippingTier,
    items,
  };

  safeEvent('add_shipping_info', eventData);
};

export const trackAddPaymentInfo = (cartItems, totalValue, paymentMethod) => {
  if (!Array.isArray(cartItems) || cartItems.length === 0) return;

  const items = cartItems.map((item) => ({
    item_id: item.id,
    item_name: item.name,
    item_brand: item.shopName,
    price: item.finalPrice,
    quantity: 1,
    item_category: item.category?.name || '',
    item_category2: item.parentCategory?.name || '',
    item_variant:
      item.serviceOption === 'rent'
        ? `${item.rentalPeriod}${item.useSubscription ? ' (subscription)' : ''}`
        : 'buy',
  }));

  const eventData = {
    currency: 'JPY',
    value: totalValue,
    payment_type: paymentMethod,
    items,
  };

  safeEvent('add_payment_info', eventData);
};


